exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.divBox[data-v-0ae01bf3] {\n  overflow-y: scroll;\n  height: 700px;\n}\n", ""]);

// exports
